import React from 'react';

const SubFieldPublication = () => {
  return (
    <div>
      <h4>
        Subfield [publication]
      </h4>
      <p>
        Date of publication of the GS1 GPC version used for generating the codes (ISO8601 date format)
      </p>
      <p>
        <strong>MANDATORY (when the product_code field exists)</strong>
      </p>
      <div>
        Example:
      </div>
      <pre>
          <code className="language-xml">
            {`<recall lang="en" xmlns="urn:recall-schema">
  <product_code>
    <publication>2011-12-01</publication>
  </product_code>
  ...
</recall>
`}
          </code>
        </pre>
    </div>
  );
};

export default SubFieldPublication;



// WEBPACK FOOTER //
// ./src/views/static/import-documentation/product-codes/sub-field-publication.js